import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CompleteLanding from "./components/CompleteLanding";
import PrivacyPolicy from "./components/legal/PrivacyPolicy";
import TermsOfService from "./components/legal/TermsOfService";
import ResponsibleDisclosure from "./components/legal/ResponsibleDisclosure";
import UseCasesLanding from "./components/use-cases/UseCasesLanding";
import EnergyUseCase from "./components/use-cases/EnergyUseCase";
import AdminDashboard from "./components/admin/AdminDashboard";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CompleteLanding />} />
          <Route path="/use-cases" element={<UseCasesLanding />} />
          <Route path="/use-cases/energy" element={<EnergyUseCase />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/responsible-disclosure" element={<ResponsibleDisclosure />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;